// pages/Conference.js
import React, { useEffect } from 'react';
import Carousel from '../components/Carousel';
function Conference() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  return (
    <div className="conference-page">

    <div style={{
      padding: '80px 0 40px',
      textAlign: 'center',
      backgroundImage: 'url(/images/cover.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      position: 'relative',
      width: '100%',
      marginLeft: 'calc(-50vw + 50%)',
      minHeight: '400px'
    }}>
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        zIndex: 1
      }}></div>
      <div className="container" style={{ position: 'relative', zIndex: 2, padding: '0 20px' }}>

      <style jsx>{`
        @media (max-width: 768px) {
          .conference-page > div:first-child {
            padding: 60px 0 30px !important;
            min-height: 300px !important;
          }
          .conference-page h1 {
            font-size: 2.5rem !important;
          }
          .conference-page h3 {
            font-size: 1.4rem !important;
          }
        }
      `}</style>
      <img
        src="/images/Asset5.png"
        alt="Conference Icon"
        style={{
          width: '80px',
          height: '80px',
          objectFit: 'contain'
        }}
      />
      <h1 style={{
        fontSize: '3.5rem',
        marginBottom: '20px',
        background: 'linear-gradient(135deg, var(--primary-orange), var(--secondary-orange))',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text'
      }}>
        ندوة
      </h1>

      <h3 style={{
        fontSize: '2rem',
        marginBottom: '20px',
        fontWeight: '600',
        lineHeight: '1.6'
      }}>
        العنف الذي تيسره التكنولوجيا ضد النساء والفتيات
        <br />
        <span style={{ color: 'var(--primary-orange)', fontSize: '1.8rem' }}>
          جائحة رقمية صامتة
        </span>
      </h3>
      <div style={{
        background: 'var(--secondary-black)',
        padding: '20px 30px',
        borderRadius: '15px',
        borderRight: '4px solid var(--primary-orange)',
        marginBottom: '25px'
      }}>
        <p style={{ fontSize: '1.3rem', marginBottom: '10px' }}>
        <img src="/images/calandarv.png" className="tab-icon3-img" /> <strong>التاريخ:</strong> الأربعاء 26 نونبر 2025
        </p>
        <p style={{ fontSize: '1.3rem' }}>
          <img src="/images/time.png" className="tab-icon3-img" /> <strong>التوقيت:</strong> ابتداء من الساعة الخامسة والنصف بعد الزوال
        </p>
      </div>
      </div>
    </div>

      {/* Conference Section */}
      <div style={{ background: 'var(--secondary-black)', padding: '60px 0' }}>
        <div className="container">



          {/* Statistics Section */}
          <div style={{ marginBottom: '50px' }}>
            <h3 style={{
              fontSize: '2.3rem',
              marginBottom: '35px',
              textAlign: 'center',
              color: 'var(--white)'
            }}>
              إحصائيات مقلقة
            </h3>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
              gap: '25px',
              marginBottom: '40px'
            }}>
              <div style={{
                background: 'var(--primary-black)',
                padding: '30px',
                borderRadius: '15px',
                textAlign: 'center',
                border: '2px solid var(--primary-orange)',
                transition: 'transform 0.3s ease'
              }}>
                <div style={{
                  fontSize: '3.5rem',
                  fontWeight: '700',
                  color: 'var(--primary-orange)',
                  marginBottom: '10px'
                }}>
                  60%
                </div>
                <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                  من النساء في المنطقة العربية يتعرضن للعنف الرقمي
                </p>
              </div>

              <div style={{
                background: 'var(--primary-black)',
                padding: '30px',
                borderRadius: '15px',
                textAlign: 'center',
                border: '2px solid var(--primary-orange)',
                transition: 'transform 0.3s ease'
              }}>
                <div style={{
                  fontSize: '3.5rem',
                  fontWeight: '700',
                  color: 'var(--primary-orange)',
                  marginBottom: '10px'
                }}>
                  1.5M
                </div>
                <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                  امرأة مغربية تتعرض للعنف الرقمي سنويا
                </p>
              </div>

              <div style={{
                background: 'var(--primary-black)',
                padding: '30px',
                borderRadius: '15px',
                textAlign: 'center',
                border: '2px solid var(--primary-orange)',
                transition: 'transform 0.3s ease'
              }}>
                <div style={{
                  fontSize: '3.5rem',
                  fontWeight: '700',
                  color: 'var(--primary-orange)',
                  marginBottom: '10px'
                }}>
                  44%
                </div>
                <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                  من حالات العنف الرقمي تنتقل إلى أرض الواقع
                </p>
              </div>

              <div style={{
                background: 'var(--primary-black)',
                padding: '30px',
                borderRadius: '15px',
                textAlign: 'center',
                border: '2px solid var(--primary-orange)',
                transition: 'transform 0.3s ease'
              }}>
                <div style={{
                  fontSize: '3.5rem',
                  fontWeight: '700',
                  color: 'var(--primary-orange)',
                  marginBottom: '10px'
                }}>
                  11%
                </div>
                <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                  فقط من الضحايا يبلغن عن العنف الرقمي
                </p>
              </div>
            </div>

            <div style={{
              background: 'linear-gradient(135deg, rgba(255, 107, 53, 0.1), rgba(255, 133, 85, 0.05))',
              padding: '35px',
              borderRadius: '15px',
              borderRight: '5px solid var(--primary-orange)'
            }}>
              <h4 style={{ fontSize: '1.6rem', marginBottom: '20px', color: 'var(--white)' }}>
                أشكال العنف الرقمي الأكثر شيوعا
              </h4>
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                gap: '15px'
              }}>
                <div>• التشهير والمعلومات الكاذبة (67%)</div>
                <div>• التحرش الإلكتروني (66%)</div>
                <div>• خطاب الكراهية  (65%)</div>
                <div>• التنمر والابتزاز الإلكتروني</div>
                <div>• التزييف العميق والذكاء الاصطناعي</div>
                <div>• الاتجار بالبشر الإلكتروني</div>
              </div>
            </div>
          </div>

          {/* Conference Objectives */}
          <div style={{ marginBottom: '50px' }}>
            <h3 style={{
              fontSize: '2.3rem',
              marginBottom: '35px',
              textAlign: 'center',
              color: 'var(--white)'
            }}>
              أهداف الندوة
            </h3>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '25px'
            }}>
              {[
                {
                  icon: '🛡️',
                  title: 'الحماية والتعبئة',
                  desc: 'ترسيخ حماية حقوق النساء والفتيات في الفضاء الرقمي وعصر الذكاء الاصطناعي'
                },
                {
                  icon: '📚',
                  title: 'التوعية والتعريف',
                  desc: 'التعريف باستخدامات التكنولوجيا المناهضة للحقوق وتعزيز فرص الوقاية منها'
                },
                {
                  icon: '🔔',
                  title: 'التحسيس والإبلاغ',
                  desc: 'النهوض بثقافة السلامة الرقمية وتشجيع التبليغ عن العنف الرقمي'
                },
                {
                  icon: '⚖️',
                  title: 'المساءلة',
                  desc: 'تسليط الضوء على مسؤوليات المنصات الكبرى في التصدي للعنف الرقمي'
                },
                {
                  icon: '🔊',
                  title: 'كسر الصمت',
                  desc: 'التشجيع على مختلف سُبل التبليغ وكسر صمت ضحايا العنف الرقمي'
                }
              ].map((item, index) => (
                <div key={index} style={{
                  background: 'var(--primary-black)',
                  padding: '25px',
                  borderRadius: '15px',
                  border: '1px solid rgba(255, 107, 53, 0.3)',
                  transition: 'all 0.3s ease'
                }}>
                  <div style={{ fontSize: '2.5rem', marginBottom: '15px' }}>{item.icon}</div>
                  <h4 style={{ fontSize: '1.4rem', marginBottom: '12px', color: 'var(--primary-orange)' }}>
                    {item.title}
                  </h4>
                  <p style={{ fontSize: '1.05rem', lineHeight: '1.7', color: 'var(--text-light)' }}>
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Conference Program */}
          <div style={{ marginBottom: '50px' }}>
            <h3 style={{
              fontSize: '2.3rem',
              marginBottom: '35px',
              textAlign: 'center',
              color: 'var(--white)'
            }}>
              برنامج الندوة
            </h3>

            <div style={{
              background: 'var(--primary-black)',
              padding: '35px',
              borderRadius: '15px',
              border: '2px solid var(--primary-orange)'
            }}>
              {[
                { time: '17:00-17:30', event: 'استراحة شاي', type: 'welcome' },
                { time: '17:30-17:45', event: 'كلمة السيدة آمنة بوعياش، رئيسة المجلس الوطني لحقوق الإنسان', type: 'opening' },
                { time: '17:45-18:00', event: 'كلمة السيدة نعيمة بن يحيى، وزيرة التضامن والإدماج الاجتماعي والأسرة', type: 'opening' },
                { time: '18:15-18:30', event: 'كلمة السيد شكيب بنموسى، المندوب السامي للتخطيط', type: 'opening' },
                { time: '18:30-18:45', event: 'كلمة السيدة مريم أوشن نصيري، ممثلة هيئة الأمم المتحدة للمرأة بالمغرب', type: 'opening' },
                { time: '18:45-19:00', event: 'مداخلة السيدة نهلة حيدر، رئيسة لجنة الأمم المتحدة للقضاء على التمييز ضد المرأة (سيداو)', type: 'keynote' },
                { time: '19:00-19:30', event: 'تفاعل المشاركات/ين', type: 'panel' },
                { time: '19:30-20:00', event: 'حفل انطلاق حملة المجلس الوطني لحقوق الإنسان (16 يوما / 12 جهة)', type: 'ceremony' }
              ].map((item, index) => (
                <div key={index} style={{
                  padding: '20px',
                  borderBottom: index < 7 ? '1px solid rgba(255, 107, 53, 0.2)' : 'none',
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '20px'
                }}>
                  <div style={{
                    background: 'linear-gradient(135deg, var(--primary-orange), var(--secondary-orange))',
                    padding: '10px 20px',
                    borderRadius: '10px',
                    fontWeight: '700',
                    fontSize: '1.1rem',
                    minWidth: '140px',
                    textAlign: 'center'
                  }}>
                    {item.time}
                  </div>
                  <div style={{ flex: 1 }}>
                    <p style={{ fontSize: '1.15rem', lineHeight: '1.7' }}>
                      {item.event}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div style={{
              marginTop: '30px',
              background: 'linear-gradient(135deg, rgba(255, 107, 53, 0.1), rgba(255, 133, 85, 0.05))',
              padding: '25px',
              borderRadius: '15px',
              textAlign: 'center'
            }}>
              <h4 style={{ fontSize: '1.4rem', marginBottom: '15px', color: 'var(--primary-orange)' }}>
                المشاركات /ون
              </h4>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--text-light)' }}>
                البرلمان • وزارة العدل • وزارة التعليم العالي  والبحث العلمي والابتكار • المجلس الاقتصادي والاجتماعي والبيئي
                <br />
                الهيئة العليا للاتصال السمعي البصري • المديرية العامة للأمن الوطني
                <br />
                اللجنة الوطنية لحماية المعطيات الشخصية • سفارة الاتحاد الأوروبي
                <br />
                جمعيات المجتمع المدني • شخصيات صحفية وإعلامية
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Mapping Show Section */}
      <div style={{ background: 'var(--primary-black)', padding: '60px 0' }}>
        <div className="container">
          <div className="section-separator" style={{ margin: '0 0 60px 0' }}></div>

          <div className="container" style={{ padding: '80px 20px 40px', textAlign: 'center' }}>
            <img
              src="/images/Asset6.png"
              alt="Conference Icon"
              style={{
                width: '80px',
                height: '80px',
                objectFit: 'contain'
              }}
            />
            <h1 style={{
              fontSize: '3.5rem',
              marginBottom: '20px',
              background: 'linear-gradient(135deg, var(--primary-orange), var(--secondary-orange))',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>
            عرض ضوئي  (Mapping show)
            </h1>
            <p style={{
              fontSize: '1.3rem',
              lineHeight: '1.9',
              marginBottom: '25px',
              color: 'var(--text-light)'
            }}>
              تجربة بصرية فنية مبتكرة باستخدام تقنية الفيديو "مابينغ" لتحويل
              واجهة مقر المجلس الوطني لحقوق الإنسان إلى لوحة فنية حية تروي قصص النساء والفتيات
              ضحايا العنف الرقمي.
            </p>
            <div style={{
              background: 'var(--secondary-black)',
              padding: '20px 30px',
              borderRadius: '15px',
              borderRight: '4px solid var(--primary-orange)',
              marginBottom: '25px'
            }}>
              <p style={{ fontSize: '1.3rem', marginBottom: '10px' }}>
                  <img src="/images/calandarv.png" className="tab-icon3-img" /> <strong> التاريخ الانطلاق الرسمي:</strong> الأربعاء 26 نونبر 2025
              </p>
              <p style={{ fontSize: '1.3rem' }}>
                <img src="/images/time.png" className="tab-icon3-img" /> <strong>الوقت: </strong>يوميا ابتداء من الساعة 19:30
              </p>
            </div>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '40px',
            alignItems: 'center'
          }}>



          </div>




          <div className="section-separator"></div>

                <div style={{ textAlign: 'center', marginTop: '50px' }}>
                  <h3 style={{
                    fontSize: '2.5rem',
                    marginBottom: '25px',
                    color: 'var(--white)'
                  }}>
              كن جزءاً من التغيير
                  </h3>

                  <p style={{
                    fontSize: '1.2rem',
                    marginTop: '30px',
                    color: 'var(--text-light)',
                    fontStyle: 'italic'
                  }}>
                معاً نكسر جدار الصمت | معاً نقف في وجه الجائحة الرقمية الصامتة
                  </p>
                </div>
        </div>
      </div>

  <Carousel />
    </div>
  );
}

export default Conference;
